/**
 * Query scope for the Coverage pill's Employer tab (BAR-3097): employer patients in Financing &
 * approval, an unverified employer included, narrowed by Administrator, Step, Location and Status.
 */

import { PATIENT_FILTER_TAG_SYSTEMS, Track, TrackLabel } from '@bariendo/lib/constants';
import { Meta } from '@medplum/fhirtypes';
import { buildCoverageFilter, tagCodes } from './coverageFilters';
import { QUEUE_FILTER_ANY, QueueFilterOption, QueueFilterValues } from './queueFilters';
import { isOpenCase } from './readyToScheduleScope';

const EMPLOYER_TRACKS: string[] = [Track.CARRUM, Track.TRANSCARENT, Track.EMPLOYER];

/** Administrator: `payor` holds the partner track, read off the `payment-track` tag. */
export const ADMINISTRATOR_FILTER_OPTIONS: QueueFilterOption[] = [
  { value: QUEUE_FILTER_ANY, label: 'All' },
  { value: Track.CARRUM, label: TrackLabel[Track.CARRUM] },
  { value: Track.TRANSCARENT, label: TrackLabel[Track.TRANSCARENT] },
];

export function buildEmployerFilter(values: QueueFilterValues): string {
  return buildCoverageFilter(values.payor === QUEUE_FILTER_ANY ? EMPLOYER_TRACKS : [values.payor], [], values);
}

/** For rows that arrive by subscription: the employer tracks and the chosen administrator. */
export function matchesEmployerTab(patient: { meta?: Meta } | undefined, values: QueueFilterValues): boolean {
  const track = tagCodes(patient, PATIENT_FILTER_TAG_SYSTEMS.track)[0];
  if (!track || !EMPLOYER_TRACKS.includes(track) || !isOpenCase(patient)) {
    return false;
  }
  return values.payor === QUEUE_FILTER_ANY || track === values.payor;
}
